import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18 13.5v5.625M4.044 24.19c-1.299 2.25.325 5.061 2.923 5.061H29.03c2.598 0 4.221-2.811 2.923-5.061L20.923 5.067c-1.299-2.25-4.548-2.25-5.847 0zm13.954-.564h.012v.011h-.012z"
	})
});
export default SvgExclamationTriangle;
